import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const UnitHeight = ({ value, onChange, patioDoorType, unitWidth, id = 'UnitHeight', label = 'Unit Height', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedHeight, setSelectedHeight] = useState(defaultValue);

    // All height options
    const allHeightOptions = [
        { id: 1, value: '79 1/4"', label: '79 1/4"' },
        { id: 2, value: '81 1/4"', label: '81 1/4"' },
        { id: 3, value: '95 1/4"', label: '95 1/4"' },
    ];

    // Widths that restrict height to (79 1/4", 95 1/4") only — no 81 1/4"
    const restrictedWidths = {
        Sliding: ['94 3/4"', '95 1/2"'],
        TripleSliding: ['143 1/4"', '143"'],
        QuadSliding: ['188 7/8"', '191 1/8"'],
    };

    // Get current door type and width values
    const doorTypeValue = patioDoorType?.value || 'Sliding';
    const currentWidth = unitWidth?.value || '';

    const isRestricted = (restrictedWidths[doorTypeValue] || []).includes(currentWidth);
    const heightOptions = isRestricted
        ? allHeightOptions.filter(opt => opt.value !== '81 1/4"')
        : allHeightOptions;

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedHeight(value?.value || '');
    }, [value?.value]);

    // Reset to first option when door type or width changes and current height is no longer valid
    useEffect(() => {
        if (heightOptions.length > 0) {
            const propValue = value?.value || selectedHeight;
            const currentValueExists = heightOptions.some(opt => opt.value === propValue);
            if (!currentValueExists) {
                const defaultOption = heightOptions[0];
                setSelectedHeight(defaultOption.value);
                onChange({ value: defaultOption.value, label: defaultOption.label });
            }
        }
    }, [doorTypeValue, currentWidth]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (heightOptions.length > 0 && !selectedHeight) {
            const defaultOption = heightOptions[0];
            setSelectedHeight(defaultOption.value);
            onChange({ value: defaultOption.value, label: defaultOption.label });
        }
    }, []);

    const handleHeightChange = (option) => {
        setSelectedHeight(option.value);
        onChange({ value: option.value, label: option.label });
    };

    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
        },
        label: {
            fontSize: '12px',
            fontWeight: '500',
            marginBottom: '2px',
        },
        radioGroup: {
            display: 'flex',
            flexDirection: 'column',
            gap: '2px',
        },
        radioLabel: {
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            fontSize: '11px',
            padding: '1px 0',
        },
        radioInput: {
            margin: 0,
            width: '12px',
            height: '12px',
            cursor: disabled ? 'not-allowed' : 'pointer',
        },
        radioText: {
            fontSize: '11px',
            color: disabled ? '#999' : '#333',
        },
    };

    return (
        <div style={styles.container}>
            <label style={styles.label} disabled={disabled}>
                {label}
            </label>
            <div style={styles.radioGroup}>
                {heightOptions.map(option => (
                    <label key={option.id} style={styles.radioLabel}>
                        <input
                            type="radio"
                            name={`${id}_${doorTypeValue}`}
                            value={option.value}
                            checked={selectedHeight === option.value}
                            onChange={() => handleHeightChange(option)}
                            disabled={disabled}
                            style={styles.radioInput}
                        />
                        <span style={styles.radioText}>{option.label}</span>
                    </label>
                ))}
            </div>
        </div>
    );
};

export default UnitHeight;
